export interface CajaBanco {
  idCajaBanco: number;
  codigo: string;
  nombre: string;
  tipoCajaBanco: string;
  numeroCuentaBancaria: string | null;
  cuentaContable: string | null;
  idMoneda: number;
  monedaNombre: string | null;
  monedaSimbolo: string | null;
  requiereNumeroOperacion: boolean;
  activo: boolean;
}

export interface CajaBancoPermiso {
  idCajaBancoPermiso: number;
  idCajaBanco: number;
  idUsuario: number;
  usuarioNombre: string | null;
  puedeConsultar: boolean;
  puedeRegistrar: boolean;
  puedeConciliar: boolean;
}

export interface TalonarioChequera {
  idTalonarioChequera: number;
  idCajaBanco: number;
  rangoInicial: string;
  rangoFinal: string;
  numeroActual: string | null;
  activo: boolean;
}

export const initialCajaBanco: CajaBanco = {
  idCajaBanco: 0,
  codigo: '',
  nombre: '',
  tipoCajaBanco: 'BANCO',
  numeroCuentaBancaria: null,
  cuentaContable: null,
  idMoneda: 0,
  monedaNombre: null,
  monedaSimbolo: null,
  requiereNumeroOperacion: false,
  activo: true,
};

export const TIPOS_CAJA_BANCO = [
  { value: 'BANCO', label: 'Banco' },
  { value: 'CAJA', label: 'Caja' },
];

export interface CajaBancoFormErrors {
  codigo?: string;
  nombre?: string;
  idMoneda?: string;
}
